import { messengerBroadcastEventEmitterService } from '@widgets/messenger/services/messengerBroadcastEventEmitterService'

const widgetChatStartedEventCode = 'widgetChatStarted'
const widgetChatClosedEventCode = 'widgetChatClosed'

export const useWidgetChatBroadcastEvents = () => {
  const emitChatStart = () => {
    messengerBroadcastEventEmitterService.emit(widgetChatStartedEventCode)
  }

  const emitChatLeave = () => {
    messengerBroadcastEventEmitterService.emit(widgetChatClosedEventCode)
  }

  const onChatStart = (callback: () => void) => {
    messengerBroadcastEventEmitterService.on(widgetChatStartedEventCode, callback)
  }

  const onChatLeave = (callback: () => void) => {
    messengerBroadcastEventEmitterService.on(widgetChatClosedEventCode, callback)
  }

  return {
    emitChatStart,
    emitChatLeave,
    onChatStart,
    onChatLeave,
  }
}
